import { Box, Button, CheckBox, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { originSection } from 'modules/project_management/lib/utils'

interface IAddProjectModalProps {
  onClose: () => void
  onSubmit: () => void
  notShowMessage: boolean
  setNotShowMessage: (value: boolean) => void
}

const ModifyHoursModal = ({
  onClose,
  onSubmit,
  notShowMessage,
  setNotShowMessage,
}: IAddProjectModalProps) => {
  track(trackingEvents.projectManagement.flexibleTracking.visitPopupWindowForChangingTime, {
    origin: originSection(),
  })

  return (
    <Modal
      illustration="document-edit"
      title={i18n.t('project_management.modals.modify_hours.title')}
      description={
        <Text size="300">{i18n.t('project_management.modals.modify_hours.description')}</Text>
      }
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button submit>{i18n.t('common.save')}</Button>
        </>
      }
    >
      <Box flexDirection="row" gap="s8" alignItems="center">
        <CheckBox checked={notShowMessage} onClick={() => setNotShowMessage(!notShowMessage)} />
        <Text.Normal>
          {i18n.t('project_management.modals.modify_hours.not_show_message')}
        </Text.Normal>
      </Box>
    </Modal>
  )
}

export default observer(ModifyHoursModal)
